export function EligibleIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_34216_25076)'>
        <path
          d='M7.37596 5.58397L5.77735 4.51823C5.44507 4.29672 5 4.53491 5 4.93426V7.06574C5 7.46509 5.44507 7.70328 5.77735 7.48177L7.37596 6.41603C7.67283 6.21811 7.67283 5.78189 7.37596 5.58397Z'
          stroke='#10B981'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.5 6C10.5 8.48528 8.48528 10.5 6 10.5C3.51472 10.5 1.5 8.48528 1.5 6C1.5 3.51472 3.51472 1.5 6 1.5C8.48528 1.5 10.5 3.51472 10.5 6Z'
          stroke='#10B981'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_34216_25076'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
